import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import styled from "styled-components";
const StyledBreak = styled.div`
  display: block;
  width: 100%;
  position: relative;
  text-align: center;
  overflow: hidden;
  color: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.borders.secondary;
}};
  font-weight: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.typography.fontWeight.bold;
}};
  font-size: 1.1rem;
  min-height: 1.1rem;
  flex-shrink: 0;
  ${_ref3 => {
  let {
    $s,
    theme
  } = _ref3;
  return theme.spacing.resolve(theme, $s);
}};

  ${_ref4 => {
  let {
    $fullWidth,
    theme
  } = _ref4;
  return $fullWidth ? `
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: ${theme.colors.borders.primary};
  }
` : `&:before,
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateX(-105%);
    width: 100%;
    height: 1px;
    background-color: ${theme.colors.borders.primary};
  }

  &:after {
    transform: translateX(5%);
  }`;
}}
`;
const Break = _ref5 => {
  let {
    s,
    children,
    ...rest
  } = _ref5;
  return /*#__PURE__*/React.createElement(StyledBreak, _extends({
    $s: s,
    $fullWidth: !children
  }, rest), children);
};
export default Break;